
export default [
    {
        path: 'download',
        component: resolve => require(['@/views/download'], resolve),
        name: 'Download',
        keepAlive: true,
        meta: {
            nav: '下载中心'
        }
    }
      
]


// WEBPACK FOOTER //
// ./src/router/download.js